import { render, staticRenderFns } from "./previsto.vue?vue&type=template&id=3da32262&"
import script from "./previsto.vue?vue&type=script&lang=js&"
export * from "./previsto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports